import { MinerChatMessage } from "@services/http/miners/dto";
import moment from "moment";
import cn from "classnames";
import { useMemo } from "react";
import styles from "./MinerChatMessageItem.module.scss";

interface MinerChatMessageItemProps {
  isAdmin: boolean;
  message: MinerChatMessage;
}

function isFrom(isAdmin: boolean, message: MinerChatMessage) {
  return isAdmin !== message.FromAdmin;
}

function formatDate(value: number | Date, format: string = "DD.MM.YYYY") {
  return moment(value).utc().format(format);
}

function MinerChatMessageItem({
  isAdmin,
  message,
}: MinerChatMessageItemProps): JSX.Element {
  const date = useMemo(() => {
    return {
      d: formatDate(message.When * 1000),
      time: formatDate(message.When * 1000, "HH:mm"),
    };
  }, [message.When]);

  const isSameDay = date.d === formatDate(new Date());

  return (
    <div
      className={cn(styles["miner-chat-item"], {
        [styles["miner-chat-item__from"]]: isFrom(isAdmin, message),
        [styles["miner-chat-item__my"]]: !isFrom(isAdmin, message),
        [styles["miner-chat-item__isAdmin"]]: isAdmin,
        [styles["miner-chat-item__isUser"]]: !isAdmin,
      })}
    >
      <div className={styles["miner-chat-item__text"]}>{message.Text}</div>
      <div className={styles["miner-chat-item__date"]}>
        {!isSameDay && `${date.d} |`} {date.time}
      </div>
    </div>
  );
}

export default MinerChatMessageItem;
